import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { LinkButton } from '../../../designSystem/button/LinkButton';
import { Flex } from '../../../designSystem/compositeComponents/FlexHelpers';
import { Tabber } from '../../../designSystem/Tabber';
import { getActiveUser } from '../../../api/adminClientApi';
import { AmorgAdminToken } from '../../../amorg-common';

type AdminTabProps =
{
    selectedTab: 'sitelogin' | 'sites' | 'users' | 'globaltemplates' | 'articles' | 'profile';
};

export function AdminTab (props: AdminTabProps): JSX.Element
{
    const [userToken, setUserToken] = React.useState<AmorgAdminToken | null>(null);

    const history = useHistory();

    React.useEffect(() => {
        +
        (async () => {
            setUserToken(await getActiveUser(() => history.push('/amorgy/login')));
        })();
    }, [])

    function handleTabChange (tab: string)
    {
        if (tab === 'sitelogin')
            history.push('/amorgy/sitelogin');
        else if (tab === 'sites')
            history.push('/amorgy/sites');
        else if (tab === 'users')
            history.push('/amorgy/users');
        else if (tab === 'globaltemplates')
            history.push('/amorgy/globaltemplates');
        else if (tab === 'articles')
            history.push('/amorgy/articles');
        else if (tab === 'profile')
            history.push('/amorgy/profile');
        else
            throw new Error('Not implemented');
    }

    return (
        <Flex flexDirection='column' gap={24}>
            <Flex justifyContent='flex-end' gap={16}>

                <Tabber
                    onClick={handleTabChange}
                    selectedTabName={props.selectedTab}
                    items={[
                        {
                            tabName: 'sitelogin',
                            text: 'Kundelogin'
                        },
                        {
                            tabName: 'sites',
                            text: 'Organisationer'
                        },
                        {
                            tabName: 'users',
                            text: 'Brugere'
                        },
                        ...(userToken?.partner === null 
                                ? [{
                                    tabName: 'globaltemplates',
                                    text: 'Survey Skabeloner'
                                }]
                                : []
                        ),
                        ...( (userToken?.partner === null || userToken?.partner === 'Crecea')
                                ? [{
                                    tabName: 'articles',
                                    text: 'Lovservice'
                                }]
                                : []
                        ),
                        {
                            tabName: 'profile',
                            text: 'Profil'
                        }
                    ]}
                />
                <LinkButton variant='outlined' text='log ud' icon="logout" href='/amorgy/logout' heightOverride='58px' />
            </Flex>
        </Flex>
    );
}